import { useRegisterSW } from 'virtual:pwa-register/react';

type Props = {
  onDismiss?: () => void;
};

/**
 * Update prompt without auto-reload — user keeps reading until they choose.
 */
export function UpdatePrompt({ onDismiss }: Props) {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    immediate: true,
  });

  if (!needRefresh) return null;

  return (
    <div className="update-banner" role="status">
      <div>
        Dostępna jest nowa wersja aplikacji. Odśwież, gdy skończysz czytać.
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          type="button"
          className="ghost-btn"
          onClick={() => {
            setNeedRefresh(false);
            onDismiss?.();
          }}
        >
          Później
        </button>
        <button
          type="button"
          className="primary-btn"
          onClick={() => updateServiceWorker(true)}
        >
          Odśwież teraz
        </button>
      </div>
    </div>
  );
}
